import { RootState } from 'redux/reducers'

export const selectIsAdobeAnalyticsAvailable = (state: RootState): boolean =>
  state.analytics.isAdobeAnalyticsAvailable
